import script from "./OrderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrderPage.vue?vue&type=style&index=0&id=76bcbcd6&lang=scss"

const __exports__ = script;

export default __exports__